import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';

import { cn } from '@/lib/utils';

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'dls-peer dls-inline-flex dls-h-6 dls-w-11 dls-shrink-0 dls-cursor-pointer dls-items-center dls-rounded-full dls-border-2 dls-border-transparent dls-shadow-10 dls-transition-colors focus-visible:dls-outline-none focus-visible:dls-ring-2 focus-visible:dls-ring-neutral focus-visible:dls-ring-offset-2 focus-visible:dls-ring-offset-background disabled:dls-cursor-not-allowed disabled:dls-opacity-50 data-[state=checked]:dls-bg-neutral data-[state=unchecked]:dls-bg-neutral-quarternary',
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'dls-pointer-events-none dls-block dls-h-5 dls-w-5 dls-rounded-full dls-bg-background dls-shadow-40 dls-ring-0 dls-transition-transform data-[state=checked]:dls-translate-x-5 data-[state=unchecked]:dls-translate-x-0'
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
